/* istanbul ignore file */

import type { HTMLAttributes } from 'react';
import { styled } from '@classify/react-core-components/styles';
import ButtonBase from '@mui/material/ButtonBase';
import { ChevronRight, ChevronLeft } from '@mui/icons-material';

export interface Props {
  onClick?: () => void;
  direction?: 'left' | 'right';
  isHidden?: boolean;
  translations: { previousLabel: string; nextLabel: string };
  buttonProps?: HTMLAttributes<HTMLButtonElement>;
}

const noop = () => {};
const ArrowButton = styled(ButtonBase, {
  shouldForwardProp: (prop) => !['direction', 'isHidden'].includes(prop as string),
})<{ direction: 'left' | 'right'; isHidden: boolean }>(({ direction, isHidden }) => ({
  position: 'absolute',
  top: '50%',
  width: 40,
  height: 40,
  transform: 'translateY(-50%)',
  display: isHidden ? 'none' : 'block',
  [direction]: -40,
  cursor: 'pointer',
}));

const ArrowIconLeft = styled(ChevronLeft)(({ theme: { palette } }) => ({
  color: palette.text.onMain,
}));
const ArrowIconRight = styled(ChevronRight)(({ theme: { palette } }) => ({
  color: palette.text.onMain,
}));
const Arrow = ({
  onClick = noop,
  direction = 'left',
  isHidden = false,
  translations,
  buttonProps = {},
}: Props) => (
  <ArrowButton
    aria-label={direction === 'left' ? translations.previousLabel : translations.nextLabel}
    onClick={onClick}
    isHidden={isHidden}
    direction={direction}
    disableRipple
    {...buttonProps}
  >
    {direction === 'left' ? <ArrowIconLeft /> : <ArrowIconRight />}
  </ArrowButton>
);

export default Arrow;
